<app-alert-card [tone]="tone()" appearance="subtle">
  <div class="notice-card__title-row">
    <span class="notice-card__title">{{ title() }}</span>
    @if (pill()) {
      <span class="lty-badge {{ pillClass() }}">{{ pill() }}</span>
    }
  </div>
  @if (description()) {
    <p class="notice-card__description">{{ description() }}</p>
  }

  @if (actionLabel()) {
    <button
      alertActions
      type="button"
      class="lty-btn notice-card__action"
      [class.lty-btn-white]="actionStyle() === 'outline'"
      [class.lty-btn-primary]="actionStyle() === 'primary'"
      [disabled]="actionDisabled()"
      [ngbTooltip]="actionTooltip()"
      (click)="action.emit()"
    >
      {{ actionLabel() }}
    </button>
  }
</app-alert-card>
